// extracted by mini-css-extract-plugin
export var light = "FreemiumUpgradeSection-module--light--u+yYz";
export var upgradeSection = "FreemiumUpgradeSection-module--upgradeSection--MaQX6";